<mat-dialog-content>
  Looks like you're away. You will be automatically logged out in {{ remainingTime }} seconds
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-button (click)="logoutUser()">Sign Out</button>
  <button mat-flat-button color="primary" (click)="continue()">Continue</button>
</mat-dialog-actions>
